// Wayne State's undergraduate majors (#2840). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Bulletin's Programs A-Z page
// (bulletins.wayne.edu/programs), which links each program under its
// college's section of the bulletin; the group is that college. Every line
// whose name carries a bachelor's degree is kept, with the degree as the
// bulletin writes it (B.A., B.S., B.S.Ed., B.F.A., B.Mus., B.P.A., B.G.S.,
// B.H.S., B.S.N., B.S.W.). "Business Administration (B.A. and B.S.)" is
// listed as two lines. The three Bachelor of Health Science concentrations
// keep the bulletin's own names. Left out: minors, certificates, the two
// co-majors (Latino/a and Latin American Studies, Peace and Conflict
// Studies), endorsements, AGRADE and LawStart. The KB's majors list was the
// starting point; the bulletin wins.
const majors = {
    "slug": "wayne-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Wayne State's official 2026-2027 Undergraduate Bulletin, grouped by the college or school that offers it, with the degree it leads to. Minors, certificates, co-majors and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Liberal Arts and Sciences",
            "source": {
                "label": "Wayne State 2026-2027 Undergraduate Bulletin, Programs A-Z",
                "url": "https://bulletins.wayne.edu/programs/"
            },
            "majors": [
                {
                    "name": "Actuarial Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "African American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Astronomy",
                    "degree": "B.A."
                },
                {
                    "name": "Astronomy",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry and Chemical Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Biological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Employment and Labor Relations",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Film Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Gender, Sexuality and Women's Studies",
                    "degree": "B.A."
                },
                {
                    "name": "General Studies",
                    "degree": "B.G.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.A."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Law",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematical Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition and Food Science",
                    "degree": "B.A."
                },
                {
                    "name": "Nutrition and Food Science",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Professional Biomedical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Public Affairs",
                    "degree": "B.P.A."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Public History",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Urban Studies and Planning",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages, Literatures, and Cultures",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Mike Ilitch School of Business",
            "source": {
                "label": "Wayne State 2026-2027 Undergraduate Bulletin, Programs A-Z",
                "url": "https://bulletins.wayne.edu/programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.A."
                },
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.A."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Entrepreneurship and Innovation",
                    "degree": "B.A."
                },
                {
                    "name": "Entrepreneurship and Innovation",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Global Supply Chain Management",
                    "degree": "B.A."
                },
                {
                    "name": "Global Supply Chain Management",
                    "degree": "B.S."
                },
                {
                    "name": "Management",
                    "degree": "B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.A."
                },
                {
                    "name": "Technology, Information Systems and Analytics",
                    "degree": "B.A."
                },
                {
                    "name": "Technology, Information Systems and Analytics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "Wayne State 2026-2027 Undergraduate Bulletin, Programs A-Z",
                "url": "https://bulletins.wayne.edu/programs/"
            },
            "majors": [
                {
                    "name": "Community Health",
                    "degree": "B.S."
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Educational Studies",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Exercise and Sport Science",
                    "degree": "B.S."
                },
                {
                    "name": "Health and Physical Education Teaching",
                    "degree": "B.S."
                },
                {
                    "name": "Middle Childhood Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Multi-Age Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Secondary Education",
                    "degree": "B.S."
                },
                {
                    "name": "Special Education",
                    "degree": "B.S."
                },
                {
                    "name": "Sport Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "James and Patricia Anderson College of Engineering",
            "source": {
                "label": "Wayne State 2026-2027 Undergraduate Bulletin, Programs A-Z",
                "url": "https://bulletins.wayne.edu/programs/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Construction Management",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical/Electronic Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Electromechanical Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "General Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Information Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Welding and Metallurgical Engineering Technology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Fine, Performing and Communication Arts",
            "source": {
                "label": "Wayne State 2026-2027 Undergraduate Bulletin, Programs A-Z",
                "url": "https://bulletins.wayne.edu/programs/"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Communication and Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.S."
                },
                {
                    "name": "Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Design and Merchandising",
                    "degree": "B.A."
                },
                {
                    "name": "Design and Merchandising",
                    "degree": "B.S."
                },
                {
                    "name": "Film",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism and Media",
                    "degree": "B.A."
                },
                {
                    "name": "Media Arts and Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music Industry and Society",
                    "degree": "B.A."
                },
                {
                    "name": "Public Relations and Strategic Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.F.A."
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "Wayne State 2026-2027 Undergraduate Bulletin, Programs A-Z",
                "url": "https://bulletins.wayne.edu/programs/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                }
            ]
        },
        {
            "name": "Eugene Applebaum College of Pharmacy and Health Sciences",
            "source": {
                "label": "Wayne State 2026-2027 Undergraduate Bulletin, Programs A-Z",
                "url": "https://bulletins.wayne.edu/programs/"
            },
            "majors": [
                {
                    "name": "Applied Health Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Laboratory Science Concentration",
                    "degree": "B.H.S."
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "B.S."
                },
                {
                    "name": "Mortuary Science",
                    "degree": "B.S."
                },
                {
                    "name": "Pharmaceutical Sciences Concentration",
                    "degree": "B.H.S."
                },
                {
                    "name": "Physical Therapy Concentration",
                    "degree": "B.H.S."
                },
                {
                    "name": "Radiation Therapy Technology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "Wayne State 2026-2027 Undergraduate Bulletin, Programs A-Z",
                "url": "https://bulletins.wayne.edu/programs/"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        }
    ]
};

export default majors;
